import { render, staticRenderFns } from "./UpsellGroupForm.vue?vue&type=template&id=6162da9c"
import script from "./UpsellGroupForm.vue?vue&type=script&lang=js"
export * from "./UpsellGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports